class PopupController {
	static SELECTOR_CLASS_POPUP = '.wp-block-jtf-jtf-popup'
	static SELECTOR_CLASS_CLOSE = '.jtf__popupblock_modal--btn-close'
	static SELECTOR_CLASS_POPUP_ACCORDION = '.jtf__popupblock_modal--accordion'
	static SELECTOR_CLASS_POPUP_TITLE = '.jtf__popupblock_modal--title'
	static SELECTOR_CLASS_POPUP_CONTENT = '.jtf__popupblock_modal--content'
	static SELECTOR_CLASS_POPUP_FORM_SUBMIT_GF = '.jtf__popupblock_modal--content input[type="submit"]'
	static SELECTOR_CLASS_GF_CONF_WRAP = '.gform_confirmation_wrapper'

	static SELECTOR_ID_MAIN_CONTENT = '#main-content'
	static SELECTOR_CLASS_SITE_LOGO = '.navigation__logo--sitetitle a'

	static ATTR_BLOCK_ID = 'data-blockid'
	static ATTR_TIMEOUT = 'data-timeout'
	static ATTR_BUTTON_TRIGGER_ID = 'data-buttonTriggerId'
	static ATTR_BUTTON_TRIGGER_ENABLE = 'data-buttonTriggerEnable'

	static PROP_FALSE = 'false'
	static PROP_TRUE = 'true'
	static PROP_DELAY = 2000

	constructor( instance ) {
		this.instance = instance
		this.init()
	}

	fadeIn( element ) {
		element.style.display = 'block'
		element.style.opacity = '0'
		let opacity = 0
		const interval = setInterval( () => {
			if ( opacity >= 1 ) {
				clearInterval( interval )
			}
			element.style.opacity = opacity.toString()
			opacity += 0.1
		}, 50 )
	}

	fadeOut( element, remove = false ) {
		element.style.opacity = '1'
		let opacity = 1
		const interval = setInterval( () => {
			if ( opacity <= 0 ) {
				clearInterval( interval )
				if ( remove ) {
					element.remove()
				} else {
					element.style.display = 'none'
				}
			}
			element.style.opacity = opacity.toString()
			opacity -= 0.1
		}, 50 )
	}

	hide() {
		this.instance.style.display = 'none'
	}

	remove() {
		this.instance.remove()
	}

	trapFocus( popupBlock ) {
		function getFocusableElements( container ) {
			return container.querySelectorAll(
				'a[href],' +
				'button:not([disabled]),' +
				'textarea:not([disabled]),' +
				'input:not([disabled]):not([type="hidden"]),' +
				'select:not([disabled]),' +
				'[tabindex]:not([tabindex="-1"])',
			)
		}

		function getFilteredFocusableElements() {
			return Array.from( getFocusableElements( popupBlock ) ).filter( isVisibleInDetails )
		}

		function isVisibleInDetails( el ) {
			let parent = el.parentElement
			let insideClosedDetails = false
			let insidePopupContent = false

			while ( parent ) {
				if ( parent.tagName === 'DETAILS' ) {
					if ( parent.open ) {
						return true
					} else {
						insideClosedDetails = true
					}
				}

				if ( parent.classList && parent.classList.contains(
					PopupController.SELECTOR_CLASS_POPUP_CONTENT.substring( 1 ),
				) ) {
					insidePopupContent = true
				}

				parent = parent.parentElement
			}

			return !(insideClosedDetails && insidePopupContent)
		}

		function keydownHandler( e ) {
			const focusableElements = getFilteredFocusableElements()
			const firstEl = focusableElements[ 0 ]
			const lastEl = focusableElements[ focusableElements.length - 1 ]

			if ( e.key === 'Tab' ) {
				if ( focusableElements.length === 0 ) {
					e.preventDefault()
					return
				}
				if ( e.shiftKey ) {
					// Shift + Tab
					if ( document.activeElement === firstEl || !popupBlock.contains( document.activeElement ) ) {
						lastEl.focus()
						e.preventDefault()
					}
				} else {
					// Tab
					if ( document.activeElement === lastEl ) {
						firstEl.focus()
						e.preventDefault()
					}
				}
			}
		}

		popupBlock.addEventListener( 'keydown', keydownHandler )

		return function cleanup() {
			popupBlock.removeEventListener( 'keydown', keydownHandler )
		}
	}

	init() {
		const mainContent = document.querySelector( PopupController.SELECTOR_ID_MAIN_CONTENT )
		const siteLogo = document.querySelector( PopupController.SELECTOR_CLASS_SITE_LOGO )

		const thisId = this.instance.getAttribute( PopupController.ATTR_BLOCK_ID )
		const time = parseInt( this.instance.getAttribute( PopupController.ATTR_TIMEOUT ) )
		const buttonTriggerId = this.instance.getAttribute( PopupController.ATTR_BUTTON_TRIGGER_ID )
		const buttonTriggerEnable = this.instance.getAttribute( PopupController.ATTR_BUTTON_TRIGGER_ENABLE )
		const triggerElement = document.getElementById( buttonTriggerId )
		const closeButton = this.instance.querySelector( PopupController.SELECTOR_CLASS_CLOSE )
		const popupBlock = this.instance.querySelector( PopupController.SELECTOR_CLASS_POPUP + ' .jtf__popupblock' )
		const accordion = this.instance.querySelector( PopupController.SELECTOR_CLASS_POPUP_ACCORDION )
		const submitFormButtonGf = this.instance.querySelector( PopupController.SELECTOR_CLASS_POPUP_FORM_SUBMIT_GF )

		if ( buttonTriggerEnable === PopupController.PROP_FALSE ) {
			setTimeout( () => {
				this.fadeIn( this.instance )
				accordion ?
					accordion.querySelector( PopupController.SELECTOR_CLASS_POPUP_TITLE ).focus()
					: closeButton.focus()
			}, time )

			if ( localStorage.getItem( thisId ) === PopupController.PROP_TRUE ) {
				this.remove()
			}
		} else {
			if ( triggerElement ) {
				triggerElement.addEventListener( 'click', ( e ) => {
					e.preventDefault()
					this.fadeIn( this.instance )
					closeButton.focus()
				} )
			}
		}

		if ( closeButton ) {
			const handleClose = () => {
				if ( buttonTriggerEnable === PopupController.PROP_FALSE ) {
					this.fadeOut( this.instance, true )
					localStorage.setItem( thisId, 'true' )
					mainContent ? mainContent.focus() : siteLogo && siteLogo.focus()
				} else {
					this.hide()
					triggerElement ? triggerElement.querySelector( 'a' ).focus() : null
				}
			}

			closeButton.addEventListener( 'click', handleClose )
			document.addEventListener( 'keydown', ( e ) => {
				if ( e.key === 'Escape' ) {
					handleClose()
				}
			} )
		}

		if ( submitFormButtonGf ) {
			const handleSubmit = () => {
				setTimeout( () => {
						if ( popupBlock.querySelector( PopupController.SELECTOR_CLASS_GF_CONF_WRAP ) ) {
							closeButton.focus()
						} else {
							submitFormButtonGf.focus()
						}
					}, PopupController.PROP_DELAY,
				)
			}
			submitFormButtonGf.addEventListener( 'click', handleSubmit )
		}

		this.trapFocus( popupBlock )
	}

	static initAll() {
		const popups = document.querySelectorAll( PopupController.SELECTOR_CLASS_POPUP )
		for ( const popup of popups ) {
			new PopupController( popup )
		}
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	PopupController.initAll()
} )